var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"get-user-page"}},[_c('vx-card',[_c('div',[_c('h5',[_vm._v(_vm._s(this.$route.params.id))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }